import { render } from "./ForgotPasswordView.vue?vue&type=template&id=f1a68740&scoped=true"
import script from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=f1a68740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a68740"],['__file',"src/views/auth/ForgotPasswordView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1a68740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1a68740', __exports__)) {
    api.reload('f1a68740', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordView.vue?vue&type=template&id=f1a68740&scoped=true", () => {
    api.rerender('f1a68740', render)
  })

}


export default __exports__